import {
    AdvancedSearchField,
    AdvancedSearchState,
    activeRules,
    normalizeAdvancedState
} from './advancedSearch';

const PREFIX = 'tevanpal.advancedSearch.';

/**
 * Salva la Ricerca Avanzata nella sessionStorage del tab: sopravvive al refresh e al ritorno
 * da una schermata di dettaglio, ma non resta "appiccicata" ai giorni successivi.
 * Le righe incomplete (ancora senza valore) non vengono salvate.
 */
export function saveAdvancedState(screen: string, state: AdvancedSearchState, fields: AdvancedSearchField[]): void {
    try {
        const rules = activeRules(state, fields);
        if (rules.length === 0) {
            sessionStorage.removeItem(PREFIX + screen);
        } else {
            sessionStorage.setItem(PREFIX + screen, JSON.stringify({match: state.match, rules}));
        }
    } catch {
        // storage non disponibile (es. modalità privata): la ricerca funziona comunque
    }
}

export function loadAdvancedState(screen: string, fields: AdvancedSearchField[]): AdvancedSearchState | null {
    try {
        const raw = sessionStorage.getItem(PREFIX + screen);
        if (!raw) {
            return null;
        }
        const state = normalizeAdvancedState(JSON.parse(raw), fields);
        return state.rules.length > 0 ? state : null;
    } catch {
        return null;
    }
}
